import { createContext } from 'react'
import type { SignSide } from '../../renderer/viewer/three/HoloBillboard'

/**
 * Set by `HoloSignPortal` to the side of the hanging stone sign a subtree is
 * embedded in, or `null` when the component renders as a normal flat DOM
 * overlay. React context flows through `createPortal`, so panels portaled into
 * a CSS3D sign face can read this even though their DOM lives elsewhere.
 *
 * Panels use it to keep detached pieces (e.g. TelemetryPanel's memory/fps cards,
 * which normally portal to `document.body` and float at viewport coords) on the
 * slab instead of escaping to the screen.
 */
export const HoloSignContext = createContext<SignSide | null>(null)
